import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@you/ui'
import MainLayout from '@/layouts/MainLayout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import Workspace from './pages/Workspace'
import Member from './pages/Workspace/member'
import Setting from './pages/Workspace/setting'
import WorkspaceApps from './pages/Workspace/apps'
import WorkspaceInvite from './pages/Workspace/invite'
import Agents from './pages/Agents/Index'
import AgentAdd from './pages/Agents/AgentAdd'
import AgentEdit from './pages/Agents/AgentEdit'
import AgentsList from './pages/Agents/List'
import AgentPublish from './pages/Agents/AgentPublish'
import Organization from './pages/Organization/Index'
import OrganizationMain from './pages/Organization/list'
import OrganizationDtails from './pages/Organization/details'
import Dataset from './pages/Knowledge/dataset'
import Knowledge from './pages/Knowledge/index'
import KnowLedgeMain from './pages/Knowledge/list'
import DatasetImport from './pages/Knowledge/datasetImport'
import DatasetDetail from './pages/Knowledge/datasetDetail'
import ChatWelcomePage from './pages/Chat/Index'
import ChatSessionPage from './pages/Chat/ChatSession'
import Dashboard from './pages/Dashboard/Index'

export default function App() {
  return (
    <>
      <Routes>
        {/* 登录页面 - 不需要认证 */}
        <Route path="/login" element={<MainLayout />} />
        
        {/* 受保护的路由 - 需要登录 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/agents/chat/80" replace />} />
          <Route path="agents" element={<Agents />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<AgentsList />} />
            <Route path="add" element={<AgentAdd />} />
            <Route path="edit/:agentId" element={<AgentEdit />} />
            <Route path="publish" element={<AgentPublish />} />
            <Route path="chat/:id" element={<ChatWelcomePage />} />
            <Route path="chat/s/:sessionId" element={<ChatSessionPage />} />
          </Route>
          <Route path="knowledge" element={<Knowledge />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<KnowLedgeMain />} />
            <Route path="dataset" element={<Dataset />} />
            <Route path="dataset-import" element={<DatasetImport />} />
            <Route path="dataset-detail" element={<DatasetDetail />} />
          </Route>
          <Route path="organization" element={<Organization />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<OrganizationMain />} />
            <Route path="details" element={<OrganizationDtails />} />
          </Route>
          <Route path="workspace" element={<Workspace />}>
            <Route path="member" element={<Member />} />
            <Route path="setting" element={<Setting />} />
            <Route path="apps" element={<WorkspaceApps />} />
          </Route>
          <Route path="chat" element={<ChatWelcomePage />} />
          <Route path="chat/s/:sessionId" element={<ChatSessionPage />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
        
        {/* 工作空间邀请页面 - 需要登录 */}
        <Route
          path="/workspace/invite"
          element={
            <ProtectedRoute>
              <WorkspaceInvite />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster position="top-center" richColors />
    </>
  )
}
